import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Text,
} from '@shared/components';

export type TaskOverdueDialogVariant = 'mark-as-done' | 'submit-review' | 'send-back';

interface TaskOverdueDialogProps {
  open: boolean;
  onClose: () => void;
  variant?: TaskOverdueDialogVariant;
}

const VARIANT_CONTENT: Record<TaskOverdueDialogVariant, { title: string; body: React.ReactNode }> =
  {
    // Owner blocked from marking a reviewed subtask as Done (Figma 10624-83861)
    'mark-as-done': {
      title: 'ไม่สามารถ Mark as Done ได้',
      body: (
        <Text>
          Task นี้เลย Due Date แล้ว กรุณาอัปเดต Due Date ของ Task
          <br />
          ก่อนเปลี่ยนสถานะ Subtask เป็น Done
        </Text>
      ),
    },
    // Assignee blocked from submitting their work/review (Figma 9424-121008)
    'submit-review': {
      title: 'Task Overdue',
      body: (
        <>
          <Text>งานนี้เลยกำหนดส่งแล้ว ไม่สามารถส่งผลการรีวิวได้</Text>
          <Text>กรุณาติดต่อเจ้าของงาน เพื่อขอขยายระยะเวลาส่งงาน</Text>
        </>
      ),
    },
    // Owner blocked from sending a reviewed subtask back (wording pending design confirmation)
    'send-back': {
      title: 'ไม่สามารถ Send Back ได้',
      body: (
        <Text>
          Task นี้เลย Due Date แล้ว กรุณาอัปเดต Due Date ของ Task
          <br />
          ก่อน Send Back Subtask นี้
        </Text>
      ),
    },
  };

/**
 * Shown when a task status change is blocked because the task's due date has passed.
 * Variant picks the wording for the blocked action. Acknowledge-only — closing keeps the
 * user on the current page and leaves the task status unchanged.
 */
export default function TaskOverdueDialog(props: Readonly<TaskOverdueDialogProps>) {
  const { open, onClose, variant = 'mark-as-done' } = props;

  const { title, body } = VARIANT_CONTENT[variant];

  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs' onClick={(e) => e.stopPropagation()}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{body}</DialogContent>
      <DialogActions>
        <Button onClick={onClose}>รับทราบ</Button>
      </DialogActions>
    </Dialog>
  );
}
